import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import NewLogo from '../NewSmartEvacLogo.png';
import axios from 'axios';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect,Component  } from "react";


const AWS = require('aws-sdk');

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});

const params = {
  TableName: "Address_table"
};




function AdminPage() {
  const navigate = useNavigate();
  const [fetched_data, setData] = useState([]);
  const [firefetched_data, firesetData] = useState([]);
  const [email, setEmail] = useState("");
  const [fname, setfname] = useState("");
  const [sname, setsname] = useState("");
  const [text, setText] = useState("");
  const [Priority, setPriority] = useState("");

  const apiUrl = "https://v33xbajfo4.execute-api.eu-west-2.amazonaws.com/deploy/send-email";

  const sendDataToApi = async () => {
    try {
      const userData = {
        type: "issue",
        email: email,
        fname: fname,
        sname: sname,
        text:text,
        Priority: Priority,
      };

      console.log(userData);
      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
    } catch (error) {
      console.error('Error sending data to API:', error);
    }
  };

  const sendIssue = async (e) => {
    e.preventDefault();
    try {
      await sendDataToApi();
      navigate('/issuemessage');
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };

  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };
  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };

  useEffect(() => {
    const dynamoDB = new AWS.DynamoDB.DocumentClient();
    dynamoDB.scan(params, (err, result) => {
      if (err) {
        console.error('Error scanning the table',err);
      } else {
        console.log('Scan succeeded:', JSON.stringify(result, null, 2));
        const filtered = result.Items.filter(FindAddress);
        setData(filtered);
        const filtered2 = result.Items.filter(FindFireAddress);
        firesetData(filtered2)
      }
    });
  }, []);

  function FindAddress(item) {
    return item.key === "1";
  }
  function FindFireAddress(item) {
    return item.key === "2";
  }

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
        <img className="app-logo" src={Logo} width="400" height="50"></img>
        </Col>
      </Row>
      <Row className="middle-page-content">
        <Col>
        <h3>Admin Page</h3>
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
              </Nav>
              <Nav className="ms-auto">
                <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <br></br>
        <br></br>
        <br></br>
        <h1>SmartEvac - A fire evacuation monitoring system utilising facial recognition for improved safety and rescue operations</h1>
        <br></br>
        <p>
        This project’s aim is to build a smart roll call solution, removing the need for
        manual registration or call-outs. It will be a means of accounting for people who
        have left the building during a fire evacuation, and ensuring emergency services
        obtain a list of anyone who is still in the premises.
        This roll call solution will implement facial recognition, where a camera will detect
        faces as people exit the building, comparing to a database and thus marking them
        as ‘safe.’ This database will be managed by the ‘responsible person’ or health
        and safety officer of that building within an audit-like platform. They will be able
        to add new people to the database  and facecard. Upon the arrival of the fire brigade, the system will display everyone
        who has not been detected, so will commence the rescue mission promptly. 
        </p>
        <br></br>
        <Row>
          <h3>Your building address</h3>
          <table className="table" >
            <thead>
              <tr>
                <th>Name</th>
                <th>Street Address</th>
                <th>Postcode</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {fetched_data.map((item, index) => (
                <tr key={index}>
                  <td>{item.CompanyName}</td>
                  <td>{item.StreetAddress}</td>
                  <td>{item.Postcode}</td>
                  <td>{item.Countrt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Row>
        <Row>
          <h3>Your closet fire brigade</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Street Address</th>
                <th>Postcode</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {firefetched_data.map((item, index) => (
                <tr key={index}>
                  <td>{item.CompanyName}</td>
                  <td>{item.StreetAddress}</td>
                  <td>{item.Postcode}</td>
                  <td>{item.Countrt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Row>
        <br></br>
        <br></br>
        <br></br>
         <Row className="justify-content-center">
            <Col xs={8} sm={8} md={8} lg={8}>
              <form className="loginForm" onSubmit={sendIssue}>
                <p className="Title">Contact Form</p>
                <p>Contact the our support team and we'll get back to you as soon as possible.</p>
                <div className="form-group">
                  <input
                    type="text"
                    name="fname"
                    placeholder="Forename"
                    onChange={(e) => setfname(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="sname"
                    placeholder="Surname"
                    onChange={(e) => setsname(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label for="cars">Priority of issue:  </label>
                  <select id="cars" name="cars" onChange={(e) => setPriority(e.target.value)}>
                    <option value="P4:Negligible">P4:Negligible</option>
                    <option value="P3:Low">P3:Low</option>
                    <option value="P2:Moderate">P2:Moderate</option>
                    <option value="P1:High">P1:High</option>
                    <option value="P0:Critical">P0:Critical</option>
                  </select>
                </div>
                <div className="form-group">
                  <textarea name="message" rows="10" cols="100" onChange={(e) => setText(e.target.value)}>
                  Describe Issue
                  </textarea>
                </div>
                <button type="submit" className="login-button">
                  Send
                </button>
              </form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPage;
